// src/components/Header.js
import React from 'react';
import Navigation from './Navigation';

const Header = () => {
  return (
    <header>
      <h1>Developer Name</h1>
      <Navigation />
    </header>
  );
};

export default Header;